import React, { useEffect } from 'react';
import { useState } from 'react';
import { StyleSheet, Text, View, SafeAreaView } from 'react-native';
import JunkSummary from './components/JunkSummary.js';
import Environmental from './components/Environmental';
import WasteApp from './components/WasteApp';
import OrigWasteApp from './components/OrigWasteApp';


//Fontawesome setup
import { library } from '@fortawesome/fontawesome-svg-core'
import {fal} from '@fortawesome/pro-light-svg-icons';

export default function App() {
	library.add(fal);

	return (
		<View style={styles.container}>
			<ShittyRouter>
			</ShittyRouter>
		</View>
	);
}

const ShittyRouter = ({ children = undefined }) => {
	const [path, setPath] = useState('/shiny');
	const portalData = {};

	useEffect(() => {
		
	}, []);

	if (path == '/app') {
		return <OrigWasteApp/>;
	}

	if (path == '/shiny') {
		return <WasteApp/>;
	}

	return <JunkSummary portalData={portalData} />;

}

const styles = StyleSheet.create({
	container: {
		width: '100%',
		padding: 10,
		flex: 1,
		backgroundColor: '#eeeeee',
		color: 'black',
	},
});
